import { apiRequest } from './client'
import type { SilkAuthConfig, SilkAuthResult, SilkUser } from './types'

export type SmsPurpose = 'register' | 'login' | 'bind_phone' | 'reset_password' | 'otp_auth'
export type EmailPurpose = 'register'

export const authApi = {
  config: () =>
    apiRequest<SilkAuthConfig>('/api/v1/auth/config', {
      auth: false,
    }),

  checkPhone: (body: { phone: string }) =>
    apiRequest<{ phone: string; registered: boolean }>('/api/v1/auth/sms/check-phone', {
      method: 'POST',
      body,
      auth: false,
    }),

  checkEmail: (body: { email: string }) =>
    apiRequest<{ email: string; registered: boolean }>('/api/v1/auth/email/check-email', {
      method: 'POST',
      body,
      auth: false,
    }),

  authenticateByPhoneOtp: (body: {
    phone: string
    sms_code: string
    referral_code?: string
    invite_code?: string
    captcha_verify_param?: string
  }) =>
    apiRequest<SilkAuthResult>('/api/v1/auth/sms/authenticate', {
      method: 'POST',
      body,
      auth: false,
    }),

  register: (body: {
    username?: string
    email?: string
    phone?: string
    sms_code?: string
    email_code?: string
    password: string
    nickname?: string
    referral_code?: string
    tenant_code?: string
    invite_code?: string
    captcha_verify_param?: string
  }) =>
    apiRequest<SilkAuthResult>('/api/v1/auth/register', {
      method: 'POST',
      body,
      auth: false,
    }),

  resetPassword: (body: {
    phone: string
    sms_code: string
    password: string
    captcha_verify_param?: string
  }) =>
    apiRequest<{ ok: boolean }>('/api/v1/auth/sms/reset-password', {
      method: 'POST',
      body,
      auth: false,
    }),

  sendSmsCode: (body: {
    phone: string
    purpose: SmsPurpose
    invite_code?: string
    captcha_verify_param?: string
  }) =>
    apiRequest<{ expires_in_sec: number; provider?: string }>(
      '/api/v1/auth/sms/send',
      {
        method: 'POST',
        body,
        auth: false,
      },
    ),

  sendEmailCode: (body: {
    email: string
    purpose: EmailPurpose
    invite_code?: string
    captcha_verify_param?: string
  }) =>
    apiRequest<{ expires_in_sec: number }>('/api/v1/auth/email/send', {
      method: 'POST',
      body,
      auth: false,
    }),

  login: (body: { login: string; password: string; captcha_verify_param?: string }) =>
    apiRequest<SilkAuthResult>('/api/v1/auth/login', {
      method: 'POST',
      body: { ...body, client: 'web' },
      auth: false,
    }),

  refresh: (refreshToken: string) =>
    apiRequest<SilkAuthResult>('/api/v1/auth/refresh', {
      method: 'POST',
      body: { refresh_token: refreshToken },
      auth: false,
    }),

  logout: (refreshToken: string) =>
    apiRequest<{ ok: boolean }>('/api/v1/auth/logout', {
      method: 'POST',
      body: { refresh_token: refreshToken },
      auth: false,
    }),

  me: () => apiRequest<SilkUser>('/api/v1/auth/me'),
}
